import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { displayName, useVerifiedUser } from '../services/authSync';

// Protected route component for admin pages. Re-checks the CURRENT token's
// user (server-confirmed) on every navigation and auth change, so a tab whose
// session was switched to a non-admin account never renders an admin page (R0).
const AdminRoute = ({ children }) => {
  const location = useLocation();
  const { checking, user } = useVerifiedUser();

  if (checking) {
    return (
      <div
        className="flex min-h-[50vh] items-center justify-center"
        aria-busy="true"
        aria-live="polite"
      >
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-indigo-600" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/admin-login"
        replace
        state={{ from: location, notice: 'Please sign in with an admin account.' }}
      />
    );
  }

  if (user.is_superuser !== true) {
    return (
      <Navigate
        to="/admin-login"
        replace
        state={{
          from: location,
          notice: `This page needs an admin account. You are signed in as ${displayName(user)}.`,
        }}
      />
    );
  }

  return children;
};

export default AdminRoute;
